export * from './room-content-item.component';